import React from "react";
import TabPanel from "../Reusable/Tab";
import EditRider from "./EditRider";

//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";

const SwitchTab = (props: any) => {
  const { profile, handleEdit } = props;
  return (
    <>
      <TabPanel
        tabTitle={["Update", "Documents"]}
        tabPanels={[
          <>
            <EditRider profile={profile} handleEdit={handleEdit} />
          </>,
          <>
            <FileUpload object_id={profile?.user?.id} />
          </>,
        ]}
      />
    </>
  );
};

export default SwitchTab;
